/**
 * =============================================================
 * AADHAV ACADEMY – ADMIN BOOK API
 * Role: Admin
 * Scope: Books & Chapters (Unified 2-Endpoint Architecture)
 * Standard: Enterprise / MNC Level
 * =============================================================
 */

import { apiCall } from "../core/apiCall";

/* =============================================================
   ENDPOINTS (Only 2 files)
============================================================= */

const ADMIN_BOOK_ENDPOINT = "/admin/books/books.php";
const ADMIN_BOOK_CHAPTER_ENDPOINT = "/admin/books/bookChapter.php";

/* =============================================================
   BOOKS API (GET & POST)
============================================================= */

/**
 * Fetch books based on course category (GET)
 */
export const getAdminBooks = async (courseCategoryId, options = {}) => {
  try {
    const query = courseCategoryId ? `?course_category_id=${courseCategoryId}` : "";
    const res = await apiCall(
      "GET",
      `${ADMIN_BOOK_ENDPOINT}${query}`,
      null,
      "Admin - Fetch Books",
      options
    );

    if (!res || res.status !== true) {
      return { success: false, message: res?.message || "Failed to fetch books", data: [] };
    }

    return { success: true, data: res.data || [] };
  } catch (error) {
    console.error("Admin Fetch Books Error:", error);
    return { success: false, message: error.message || "Unexpected error occurred", data: [] };
  }
};

/**
 * Add or Update a Book (POST - Supports multipart/form-data for PDFs & Invoices)
 */
export const saveAdminBook = async (formData, options = {}) => {
  try {
    const res = await apiCall(
      "POST",
      ADMIN_BOOK_ENDPOINT,
      formData,
      "Admin - Save Book",
      options
    );

    if (!res || res.status !== true) {
      return { success: false, message: res?.message || "Failed to save book data" };
    }

    return { success: true, message: res.message || "Book saved successfully", book_id: res.book_id };
  } catch (error) {
    console.error("Admin Save Book Error:", error);
    return { success: false, message: error.message || "Unexpected error occurred while saving book" };
  }
};

/* =============================================================
   BOOK CHAPTERS API (GET & POST)
============================================================= */

/**
 * Fetch chapters for a specific book (GET)
 */
export const getAdminBookChapters = async (bookId, options = {}) => {
  try {
    const query = bookId ? `?book_id=${bookId}` : "";
    const res = await apiCall(
      "GET",
      `${ADMIN_BOOK_CHAPTER_ENDPOINT}${query}`,
      null,
      "Admin - Fetch Book Chapters",
      options
    );

    if (!res || res.status !== true) {
      return { success: false, message: res?.message || "Failed to fetch book chapters", data: [] };
    }

    return { success: true, data: res.data || [] };
  } catch (error) {
    console.error("Admin Fetch Book Chapters Error:", error);
    return { success: false, message: error.message || "Unexpected error occurred", data: [] };
  }
};

/**
 * Add or Update a Book Chapter (POST)
 */
export const saveAdminBookChapter = async (chapterData, options = {}) => {
  try {
    const res = await apiCall(
      "POST",
      ADMIN_BOOK_CHAPTER_ENDPOINT,
      chapterData,
      "Admin - Save Book Chapter",
      options
    );

    if (!res || res.status !== true) {
      return { success: false, message: res?.message || "Failed to save chapter" };
    }

    return { success: true, message: res.message || "Chapter saved successfully" };
  } catch (error) {
    console.error("Admin Save Book Chapter Error:", error);
    return { success: false, message: error.message || "Unexpected error occurred while saving chapter" };
  }
};